import { useTranslation } from 'react-i18next'
import { LogIn } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/**
 * "Já é membro? Entre para ver se você já tem acesso" with a secondary
 * "Entrar" (David, 2026-10-30): the one invitation to sign in on a padlocked
 * space, the same in every case, right under the headline. The login comes
 * back to the space, which checks the access again.
 */
export function SignInInvite({ onSignIn, className }: { onSignIn: () => void; className?: string }) {
  const { t } = useTranslation('common')
  return (
    <div className={cn('flex flex-wrap items-center gap-x-3 gap-y-2', className)} data-offer-sign-in-invite>
      <p className="text-sm text-gray-700">{t('access.offer.signInInvite')}</p>
      <Button variant="outline" size="sm" className="bg-white" onClick={onSignIn} data-offer-sign-in>
        <LogIn className="mr-1.5 h-4 w-4" aria-hidden="true" />
        {t('access.denied.signIn')}
      </Button>
    </div>
  )
}
